import * as React from "react";
import { Flag } from "lucide-react";

import { cn } from "@/lib/utils";

interface PriorityOnlyToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function PriorityOnlyToggle({ checked, onCheckedChange }: PriorityOnlyToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        "inline-flex h-9 shrink-0 cursor-pointer select-none items-center gap-2 whitespace-nowrap rounded-full border pl-1.5 pr-1.5 transition-[background-color,border-color,box-shadow,color] duration-200",
        "focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-sky-400/40",
        checked
          ? "border-sky-400/70 bg-linear-to-r from-sky-50 via-white to-sky-50 text-sky-800 shadow-[0_1px_2px_rgba(14,165,233,0.16),inset_0_1px_0_rgba(255,255,255,0.8)]"
          : "border-slate-200 bg-white text-slate-600 shadow-xs hover:border-slate-300 hover:bg-slate-50"
      )}
    >
      <span
        className={cn(
          "flex size-6 items-center justify-center rounded-full transition-colors duration-200",
          checked ? "bg-sky-500 text-white shadow-sm shadow-sky-500/30" : "bg-slate-100 text-slate-400"
        )}
      >
        <Flag
          className={cn("size-3 transition-transform duration-200", checked && "fill-current")}
          aria-hidden="true"
        />
      </span>
      <span className={cn("pr-0.5 text-sm font-medium tracking-tight", checked ? "text-sky-900" : "text-slate-700")}>
        My priority projects only
      </span>
      <span
        aria-hidden="true"
        className={cn(
          "relative inline-flex h-[18px] w-8 shrink-0 items-center rounded-full transition-colors duration-200",
          checked ? "bg-sky-500" : "bg-slate-200"
        )}
      >
        <span
          className={cn(
            "absolute top-[2px] left-[2px] size-3.5 rounded-full bg-white shadow-sm transition-transform duration-200 ease-out",
            checked && "translate-x-[14px]"
          )}
        />
      </span>
    </button>
  );
}
